// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Holding } from '@daml.js/splice-api-token-holding/lib/Splice/Api/Token/HoldingV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useTokenStandardHoldings: () => UseQueryResult<InterfaceContract<Holding>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryTokenStandardHoldings', offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryTokenStandardHoldings(offset!);
    },
    enabled: !!offset,
  });
};

export default useTokenStandardHoldings;
